import { render, staticRenderFns } from "./DailyVisits.vue?vue&type=template&id=6ba3511e"
import script from "./DailyVisits.vue?vue&type=script&lang=js"
export * from "./DailyVisits.vue?vue&type=script&lang=js"
import style0 from "./DailyVisits.vue?vue&type=style&index=0&id=6ba3511e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports